/* Local dependencies */
import { Warehouse } from '../../types';

export enum GetWarehouseActionTypes {
  GET_WAREHOUSE = 'GET_WAREHOUSE',
  GET_WAREHOUSE_SUCCESS = 'GET_WAREHOUSE_SUCCESS',
  GET_WAREHOUSE_ERROR = 'GET_WAREHOUSE_ERROR',
}

export interface GetWarehouseRequest {
  type: GetWarehouseActionTypes.GET_WAREHOUSE;
  warehouseId: string;
}

export interface GetWarehouseSuccess {
  type: GetWarehouseActionTypes.GET_WAREHOUSE_SUCCESS;
  warehouse: Warehouse;
}

export interface GetWarehouseError {
  type: GetWarehouseActionTypes.GET_WAREHOUSE_ERROR;
  error: Error;
}

export type GetWarehouseAction = GetWarehouseRequest | GetWarehouseSuccess | GetWarehouseError;
